// Copyright ©️ 2026 eVolve MEP, LLC

import React from 'react';

import { useEvolvePaginatedGet } from '@evolvemep/api-ts';

import type { GlobalFilterProps } from 'components/Mantine/GlobalFilters/types';
import { SearchableMultiSelect } from 'components/Mantine/TypeSafeSelect/PaginatedSelectors/SearchableMultiSelect';
import { useUser } from 'hooks/user/useUser';

export const ProjectsFilter = ({ filter, value, onChange }: GlobalFilterProps<'projects'>) => {
  const { user } = useUser();

  const projectPaginatedGet = useEvolvePaginatedGet('shop/project', {
    defaultConfig: { params: { orderBy: ['currentUserAssigned:desc', 'projectName:asc'] } },
  });
  const hasGroups = projectPaginatedGet.data.some((p) => p.members.some((assignee) => assignee.userId === user.userId));

  if (!filter) return null;

  return (
    <SearchableMultiSelect
      placeholder="All Projects"
      clearable
      label="Projects"
      getGroup={
        hasGroups
          ? (p) => (p.members.some((assignee) => assignee.userId === user.userId) ? 'My projects' : 'Other projects')
          : undefined
      }
      paginatedGet={projectPaginatedGet}
      value={value}
      onChange={onChange}
      idKey="projectId"
      getItemLabel={(i) => i.projectName}
      hidePickedOptions={false}
      comboboxProps={{ withinPortal: false }}
      preloadData
    />
  );
};
